var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "audiology-kpis__filter--compare" }, [
    _c("span", { staticClass: "audiology-kpis__filter--label" }, [
      _vm._v("COMPARISONS:")
    ]),
    _vm._v(" "),
    _c("span", {
      staticClass: "glyphicon glyphicon-usd circleBtn compNumber",
      on: {
        click: function($event) {
          return _vm.changeCompMode("number")
        }
      }
    }),
    _vm._v(" "),
    _c(
      "span",
      {
        staticClass: "circleBtn compPercent",
        on: {
          click: function($event) {
            return _vm.changeCompMode("percent")
          }
        }
      },
      [_vm._v("%")]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }